import React from "react";

import cx from "classnames";
import { css } from "@emotion/react";

import { COLORS } from "styles-js";


const styles = css({
  cursor: "text",
  color: COLORS.charcoalGrey,
  fontSize: 16
});

interface FormLabelProps {
  htmlFor: string;
  className?: string;
  children?: React.ReactNode;
  [key: string]: any;
}

export default function FormLabel({
  htmlFor,
  className,
  children,
  ...restProps
}: FormLabelProps) {

  if (!children) {
    return null;
  }

  return (
    <label
      htmlFor={htmlFor}
      className={cx("form-label", className)}
      css={styles}
      {...restProps}>
      {children}
    </label>
  );
}
